export const DEFAULT_DATE_PICKER_MIN_DATE = new Date('2000-01-01');

export const DEFAULT_DATE_PICKER_MAX_DATE = new Date('2100-12-31');
